import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
        <h1 className="text-6xl font-heading text-foreground-200">404</h1>
        <p className="mt-4 text-foreground-500">页面未找到</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-300">
          返回首页
        </Link>
      </div>
    </Layout>
  );
}